import * as React from 'react';
import loadable from '@loadable/component';
import { withRouter } from 'react-router';
const FilterContainer = loadable(() => import('./FilterContainer'));
function RouteWrapper(props) {
    // Wrap with withRouter but only pass needed vals
    return (React.createElement(FilterContainer, { defaultFilters: props.defaultFilters, onFilterChange: props.onFilterChange, persistFiltersById: props.persistFiltersById, location: props.location, disableParamChange: props.disableParamChange }, props.children));
}
export default withRouter(RouteWrapper);
//# sourceMappingURL=FilterContainerWrapper.js.map